import { PropertyWalletDetailsDTO, PropertyWalletItemDTO } from '../../../services/properties';

export const formatPropertyIdentification = (
  item: Pick<PropertyWalletItemDTO, 'identification' | 'alias' | 'publicId'>
): string => {
  if (item.identification) return item.identification;
  if (item.alias) return item.alias;
  return item.publicId || '—';
};

export const formatPropertyAddress = (
  address?: PropertyWalletItemDTO['address']
): string => {
  const parts = [
    address?.street,
    address?.number,
    address?.complement,
    address?.neighborhood
  ].filter(Boolean);

  if (parts.length) return parts.join(', ');
  return address?.formatted || '—';
};

export const formatPropertyCityState = (
  address?: PropertyWalletItemDTO['address']
): string => {
  const city = address?.city;
  const state = address?.state;
  if (city && state) return `${city}/${state}`;
  return city || state || '';
};

export const mergePropertyDetails = (
  shell: PropertyWalletItemDTO,
  remote?: PropertyWalletDetailsDTO | null
): PropertyWalletDetailsDTO => {
  if (!remote) {
    return {
      publicId: shell.publicId,
      id: shell.id,
      identification: shell.identification,
      alias: shell.alias,
      area: shell.area,
      score: shell.score,
      activeProcesses: shell.activeProcesses,
      updatedAt: shell.updatedAt,
      address: shell.address,
      type: shell.type
    };
  }

  return {
    ...remote,
    identification: remote.identification || shell.identification,
    alias: remote.alias || shell.alias,
    area: remote.area ?? shell.area,
    score: remote.score ?? shell.score,
    activeProcesses: remote.activeProcesses || shell.activeProcesses,
    updatedAt: remote.updatedAt || shell.updatedAt,
    address: {
      ...shell.address,
      ...remote.address,
      formatted: remote.address?.formatted || shell.address?.formatted
    },
    type: {
      ...shell.type,
      ...remote.type
    }
  };
};
